import { DropdownContext } from '@components/DropdownContext';
import { ErrorHandlingModal } from '@components/ErrorHandlingModal';
import { ModalLoading } from '@components/ModalLoading';
import { RequestStatus } from '@features/request/requestSlice';
import { useRequest } from '@features/request/useRequest';
import { cnMixSpace, IconArrowDown } from '@uikit';
import { downloadURI } from '@utils/downloadDataURI';

import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { exportCatalogUerBaseCostGql } from '../../catalogUerBaseCostQueries';

const titleText = 'Выгрузить справочник';

export const CatalogUerBaseCostExport = ({ disabled }: { disabled: boolean }) => {
    const { id: catalogUniqueId } = useParams();
    const dispatch = useDispatch();
    const [isSubmittedExport, setIsSubmittedExport] = useState<boolean>(false);

    const [
        exportCatalogData,
        exportCatalogStatus,
        exportCatalogError,
        exportCatalogRequest,
        setExportCatalogData,
        exportCatalogAbort,
    ] = useRequest({
        requestId: 'exportCatalogUerBaseCost',
        query: exportCatalogUerBaseCostGql,
        withEffect: false,
    });

    useEffect(() => {
        if (
            isSubmittedExport &&
            exportCatalogStatus === RequestStatus.SUCCESS &&
            exportCatalogData?.exportCatalogUERAsExcel?.data
        ) {
            const { dataUrl, name } = exportCatalogData.exportCatalogUERAsExcel.data;

            downloadURI(dataUrl, name);
            setExportCatalogData(undefined);
            setIsSubmittedExport(false);
        }
    }, [dispatch, setExportCatalogData, exportCatalogData, exportCatalogStatus, isSubmittedExport]);

    const handleDownload = () => {
        if (!catalogUniqueId) {
            return;
        }

        dispatch(exportCatalogRequest({ catalogUniqueId }));
        setIsSubmittedExport(true);
    };

    const handleAbort = () => {
        dispatch(exportCatalogAbort());
        setIsSubmittedExport(false);
    };

    return (
        <>
            <DropdownContext
                items={[
                    {
                        label: 'Выгрузить в формате xlsx',
                        action: handleDownload,
                    },
                ]}
                btnLabel={titleText}
                btnView="secondary"
                btnSize="s"
                btnIconSize="s"
                icon={IconArrowDown}
                wrapperClassName={cnMixSpace({
                    mL: 's',
                })}
                isDropdownWidthMatchBtn
                isDisabled={disabled}
            />

            <ErrorHandlingModal
                titleText={titleText}
                isSubmitted={isSubmittedExport}
                statusRequest={exportCatalogStatus}
                errorsRequest={exportCatalogError}
                dataRequest={exportCatalogData?.exportCatalogUERAsExcel}
                handleCloseModalError={handleAbort}
            />

            {isSubmittedExport && <ModalLoading title={titleText} onClose={handleAbort} />}
        </>
    );
};

CatalogUerBaseCostExport.displayName = 'CatalogUerBaseCostExport';
